import React from 'react';
import {
    IOption,
    IOrderDetails,
    IPairAidPart,
    IProductDetail,
    ISelectedOptionIds,
} from '../../../../models/product-detail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findIcon } from '../../../common/constants';
import OptionsRadio from './options-radio';
import OptionsSelectDropDown from './options-select-drop-down';
import { useIntl } from 'react-intl';
import { useMaterialOptionsHook } from '../../../../hooks/material-options-hook';
import { isAvailableForSide } from './option-side-checking';

interface ISingleInlineProps {
    orderDetails: IOrderDetails;
    optionType: IOption;
    selectedIdsState: ISelectedOptionIds;
    side: string;
    addSelectsToOrder: (
        optionsAvailable: IOption[],
        event: React.ChangeEvent<any>,
        side: string
    ) => void;
    updateCrosPairAid: (pairAid?: IPairAidPart) => void;
    productDetails: IProductDetail;
    optionObject?: IOption;
    isEarmold?: boolean;
    country: string;
}

export default function SingleInline({
    orderDetails,
    optionType,
    selectedIdsState,
    side,
    addSelectsToOrder,
    updateCrosPairAid,
    productDetails,
    optionObject,
    isEarmold,
    country,
}: ISingleInlineProps) {
    const intl = useIntl();
    const materialHHSMessage = useMaterialOptionsHook(
        country,
        optionType.id,
        orderDetails.earmoldCategory,
        selectedIdsState,
        side,
        isEarmold
    );

    return (
        /* Checking to see if there is only one option and it is selected */
        optionType.items.length === 1 ||
            (optionType.items.filter(
                (x) => x.isAvailableRight && x.isAvailableLeft && !x.hidden
            ).length === 1 &&
                selectedIdsState.rightSelectedIds.includes(
                    optionType.items[0].id
                ) &&
                selectedIdsState.leftSelectedIds.includes(
                    optionType.items[0].id
                )) ? (
            <h4>
                <FontAwesomeIcon
                    icon={findIcon('fad', 'check')}
                    className="font-green"
                />{' '}
                {optionType.items[0].name}
            </h4>
        ) : (
            <>
                <OptionsRadio
                    name={optionType.name}
                    options={Array.from(
                        new Set(
                            optionType.items.filter((x) => {
                                if (
                                    isAvailableForSide(
                                        side,
                                        x.isAvailableLeft,
                                        x.isAvailableRight
                                    ) &&
                                    !x.hidden
                                ) {
                                    return {
                                        value: x.id,
                                        text: x.name,
                                    };
                                }
                            })
                        )
                    )}
                    value={
                        optionType.items.find(
                            (x) =>
                                (side !== 'L' &&
                                    selectedIdsState.rightSelectedIds.includes(
                                        x.id
                                    )) ||
                                (side !== 'R' &&
                                    selectedIdsState.leftSelectedIds.includes(
                                        x.id
                                    ))
                        )
                            ? optionType.items.find(
                                  (x) =>
                                      (side !== 'L' &&
                                          selectedIdsState.rightSelectedIds.includes(
                                              x.id
                                          )) ||
                                      (side !== 'R' &&
                                          selectedIdsState.leftSelectedIds.includes(
                                              x.id
                                          ))
                              )!.id
                            : ''
                    }
                    onChange={(event) =>
                        addSelectsToOrder(optionType.items, event, 'both')
                    }
                    materialHHSMessage={materialHHSMessage}
                />
                {productDetails.crosHearingAidTechnologies &&
                    (selectedIdsState!.rightSelectedIds.includes(511) ||
                        selectedIdsState!.leftSelectedIds.includes(511)) &&
                    optionType.id === 64 && (
                        <OptionsSelectDropDown
                            name={'hearingAidTechnologySelection'}
                            label={intl.formatMessage({
                                id: 'Hearing_Aid_Technology',
                                defaultMessage: 'Hearing Aid Technology',
                            })}
                            options={Array.from(
                                new Set(
                                    productDetails.crosHearingAidTechnologies.map(
                                        (x) => {
                                            return {
                                                ...optionObject!,
                                                id: x.designId,
                                                name: x.displayName,
                                            };
                                        }
                                    )
                                )
                            )}
                            hasDefaultOption={true}
                            defaultOption={
                                intl.formatMessage({
                                    id: 'Select',
                                    defaultMessage: 'Select',
                                }) + '...'
                            }
                            labelClassName={'col-sm-12'}
                            value={
                                orderDetails!.pairAid
                                    ? orderDetails.pairAid.designId
                                    : ''
                            }
                            onChange={(e) =>
                                updateCrosPairAid(
                                    productDetails.crosHearingAidTechnologies.find(
                                        (x) =>
                                            x.designId ===
                                            parseInt(e.target.value)
                                    )!
                                )
                            }
                        />
                    )}
            </>
        )
    );
}
